// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyStateNoData {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: #f1f2fa;
}
.EmptyStateNoData > svg {
  margin: 30px 0;
  height: 97px;
}
.EmptyStateNoData > div {
  margin-left: 40px;
  flex-direction: column;
  width: 240px;
}
.EmptyStateNoData > div h3 {
  font-weight: bold;
  font-size: 20px;
  line-height: 25px;
  color: var(--gray_dark2);
  padding-bottom: 10px;
}
.EmptyStateNoData > div p {
  font-size: 12px;
  line-height: 15px;
  color: var(--gray_dark2);
}`, "",{"version":3,"sources":["webpack://./src/components/EmptyStateNoData/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACE;EACE,cAAA;EACA,YAAA;AACJ;AAEE;EACE,iBAAA;EACA,sBAAA;EACA,YAAA;AAAJ;AAEI;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,oBAAA;AAAN;AAGI;EACE,eAAA;EACA,iBAAA;EACA,wBAAA;AADN","sourcesContent":[".EmptyStateNoData {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  background: #f1f2fa;\n\n  > svg {\n    margin: 30px 0;\n    height: 97px;\n  }\n\n  > div {\n    margin-left: 40px;\n    flex-direction: column;\n    width: 240px;\n\n    h3 {\n      font-weight: bold;\n      font-size: 20px;\n      line-height: 25px;\n      color: var(--gray_dark2);\n      padding-bottom: 10px;\n    }\n\n    p {\n      font-size: 12px;\n      line-height: 15px;\n      color: var(--gray_dark2);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
